import type { Vehicle } from "@/lib/types";
import { TIERS, getTier } from "@/lib/pricing";

interface TierTableProps {
  vehicle: Vehicle;
  selectedDays: number | null;
}

export default function TierTable({ vehicle, selectedDays }: TierTableProps) {
  const activeTier = selectedDays !== null ? getTier(selectedDays) : null;

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4">
      <div className="text-sm font-semibold text-gray-900 mb-3">
        Kaina pagal trukmę
      </div>
      <table className="w-full text-sm">
        <tbody>
          {TIERS.map((tier) => {
            const price = Number(vehicle[tier.field]);
            const isActive = activeTier?.field === tier.field;
            return (
              <tr
                key={tier.field}
                className={
                  isActive
                    ? "bg-blue-100 text-blue-900"
                    : "text-gray-700"
                }
              >
                <td className="py-1.5 pl-2 pr-2 rounded-l-md">
                  {tier.label}
                  {isActive && <span className="ml-1">✓</span>}
                </td>
                <td className="py-1.5 pl-2 pr-2 text-right font-semibold rounded-r-md">
                  {price}&nbsp;&euro;
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
